import { configureStore } from "@reduxjs/toolkit";
import productsSlice from "../features/products/products-slice";

const store = configureStore({
  reducer: {
    products: productsSlice,
  },
});

export default store;
